import { Box, Grid, Link, Typography } from '@mui/material'

const radius = 0
const boxShadow = '1px 1px 5px #dddddd'
const borderSize = 0
import { LogEventOnPageLoad } from '../../../components'
import { EVENTS } from '../../../constants'
function ContactUs() {
  return (
    <div>
      <LogEventOnPageLoad event={EVENTS.contact.landed} />
      <Grid container sx={{ width: '100%', backgroundColor: '#314367' }}>
        <Grid item xs={12} mb={23} mt={12.5}>
          <Grid container direction={'column'} textAlign="center">
            <Grid item xs>
              <Typography variant="h1" color="white" fontSize={52}>
                Shipping Policy
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: -100,
          marginBottom: 50,
        }}
      >
        <Grid container rowSpacing={4} columnSpacing={4} sx={{ width: '70%' }}>
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              p={2}
              mb={4}
              sx={{
                border: borderSize,
                boxShadow: boxShadow,
                borderRadius: radius,
                borderColor: 'lightgray',
                backgroundColor: 'white',
              }}
            >
              <Grid item>
                <Typography variant="h2">shipping Policy</Typography>
              </Grid>
              <Grid item>
                <br />
                <Typography variant="subtitle1">
                  Shipping is not applicable for business.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default ContactUs
